<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
                                 <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>Blog Mansory Page<small><i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1>
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><a href="#">Apps</a></li>
                <li class="active">Blog Mansory Page</li>
            </ol>
        </section>
            <!-- Main content -->
            <section class="content">
                <div class="row-mansory">
                    <!-- VIDEO -->
                    <div class="col-md-4">
                        <div class="well-media">
                            <div class="vendor">
                                <div class="fluid-width-video-wrapper embed-responsive embed-responsive-16by9">
                                    <iframe class="embed-responsive-item" src="http://www.youtube.com/embed/BO03CROMVjo" frameborder="0" allowfullscreen="" id="fitvid741674"></iframe>
                               
    </div>
                            </div>
                            <div class="video-text">
                                <h2>Baby Shark Dance | Sing and Dance! | Animal Songs | PINKFONG Songs for Children
</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus et dui id justo rhoncus consequat. Aliquam porttitor, arcu quis ornare ultricies, augue neque fringilla turpis.</p>
                            </div>
                            <div class="tag-nest"> <i>angel</i><i>dark</i><i>mistic</i> </div>
                            <div class="video-category-bg">
                                <h3>Video</h3>
                                <a class="link-media pull-right" href="#"> <span class="fontawesome-film"></span> </a>
                                <div class="triangle-white"></div>
                                <div class="triangle-video-right"></div>
                            </div>
                        </div>
                    </div>
                    <!-- END OF VIDEO -->
                    <!-- PHOTO -->
                    <div class="col-md-4">
                        <div class="well-media">
                            <div class="vendor">
                                <a class="fancybox" rel="group" href="#"> <img class="img-responsive-media" src="https://source.unsplash.com/collection/190727/1500x900" alt=""> </a>
                            </div>
                            <div class="video-text">
                                <h2>Black Angel</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            </div>
                            <div class="tag-nest"> <i>angel</i><i>dark</i><i>mistic</i> </div>
                            <div class="photo-category-bg">
                                <h3>Photo</h3>
                                <a class="link-media pull-right" href="#"> <span class="fontawesome-picture"></span> </a>
                                <div class="triangle-white"></div>
                                <div class="triangle-photo-right"></div>
                            </div>
                        </div>
                    </div>
                    <!-- END OF PHOTO -->
                    <!-- AUDIO -->
                    <div class="col-md-4">
                        <div class="well-media">
                            <div class="vendor embed-responsive embed-responsive-16by9">
                                 <iframe class="embed-responsive-item" src="http://www.youtube.com/embed/dqb4o3ycv4k" frameborder="0" allowfullscreen="" id="fitvid741674"></iframe>
                               
    </div>
                            <div class="video-text">
                                <h2>Coldplay ft The Chainsmokers - Look What You Made Me Do</h2>
                                <p>I do not own the music and the background.

Copyright Disclaimer Under Section 107 of the Copyright Act 1976</p>
                            </div>
                            <div class="tag-nest"> <i>patah </i><i>hati</i><i>music</i> </div>
                            <div class="audio-category-bg">
                                <h3>audio</h3>
                                <a class="link-media pull-right" href="#"> <span class="entypo-note-beamed"></span> </a>
                                <div class="triangle-white"></div>
                                <div class="triangle-audio-right"></div>
                            </div>
                        </div>
                    </div>
                    <!-- END OF AUDIO -->
                    <!-- PHOTO SET -->
                    <div class="col-md-4">
                        <div class="well-media">
                            <div class="vendor">
                                <div data-ride="carousel" class="carousel slide" id="carousel-example-generic">
                                    <ol class="carousel-indicators">
                                        <li class="" data-slide-to="0" data-target="#carousel-example-generic"></li>
                                        <li data-slide-to="1" data-target="#carousel-example-generic" class="active"></li>
                                        <li data-slide-to="2" data-target="#carousel-example-generic" class=""></li>
                                    </ol>
                                    <div class="carousel-inner">
                                        <div class="item"> <img class="img-responsive-media" alt="First slide" src="https://source.unsplash.com/collection/431862/800x600"> </div>
                                        <div class="item active"> <img class="img-responsive-media" alt="Second slide" src="https://source.unsplash.com/collection/474045/800x600"> </div>
                                        <div class="item"> <img class="img-responsive-media" alt="Third slide" src="https://source.unsplash.com/collection/981639/800x600"> </div>
                                    </div>
                                    <a data-slide="prev" href="#carousel-example-generic" class="left carousel-control"> <span class="devin-panel-car ti-arrow-circle-left"></span> </a>
                                    <a data-slide="next" href="#carousel-example-generic" class="right carousel-control"> <span class="devin-panel-car ti-arrow-circle-right"></span> </a>
                                </div>
                            </div>
                            <div class="video-text">
                                <h2>Holyday</h2>
                                <p>It ws may last summer holyday</p>
                            </div>
                            <div class="tag-nest"> <i>angel</i><i>dark</i><i>mistic</i> </div>
                            <div class="album-category-bg">
                                <h3>Photoset</h3>
                                <a class="link-media pull-right" href="#"> <span class="entypo-picture"></span> </a>
                                <div class="triangle-white"></div>
                                <div class="triangle-album-right"></div>
                            </div>
                        </div>
                    </div>
                    <!--     END OF PHOTO SET -->
                    <!-- VIDEO -->
                    <div class="col-md-4">
                        <div class="well-media">
                            <div class="vendor">
                                <div class="fluid-width-video-wrapper embed-responsive embed-responsive-16by9">
                                    <iframe class="embed-responsive-item" src="//www.youtube.com/embed/ICAisYcDNqw" frameborder="0" allowfullscreen="" id="fitvid892886"></iframe>
                                </div>
                            </div>
                            <div class="video-text">
                                <h2>Black Angel</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus et dui id justo rhoncus consequat. Aliquam porttitor, arcu quis ornare ultricies, augue neque fringilla turpis.</p>
                            </div>
                            <div class="tag-nest"> <i>angel</i><i>dark</i><i>mistic</i> </div>
                            <div class="video-category-bg">
                                <h3>Video</h3>
                                <a class="link-media pull-right" href="#"> <span class="fontawesome-film"></span> </a>
                                <div class="triangle-white"></div>
                                <div class="triangle-video-right"></div>
                            </div>
                        </div>
                    </div>
                    <!-- END OF VIDEO -->
                    <!-- PHOTO -->
                    <div class="col-md-4">
                        <div class="well-media">
                            <div class="vendor">
                                <a rel="group" href="#"> <img class="img-responsive-media" src="http://lorempixel.com/output/food-h-c-350-450-8.jpg" alt=""> </a>
                            </div>
                            <div class="video-text">
                                <h2>Black Angel</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            </div>
                            <div class="tag-nest"> <i>angel</i><i>dark</i><i>mistic</i> </div>
                            <div class="photo-category-bg">
                                <h3>Photo</h3>
                                <a class="link-media pull-right" href="#"> <span class="fontawesome-picture"></span> </a>
                                <div class="triangle-white"></div>
                                <div class="triangle-photo-right"></div>
                            </div>
                        </div>
                    </div>
                    <!-- END OF PHOTO -->
                    <!-- AUDIO -->
                    <div class="col-md-4">
                        <div class="well-media">
                            <div class="vendor">
                                <iframe width="100%" height="166" scrolling="no" frameborder="no" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/88278446&amp;color=ff5500&amp;auto_play=false&amp;hide_related=false&amp;show_artwork=true"></iframe>
                            </div>
                            <div class="video-text">
                                <h2>Favright</h2>
                                <p>Favright - Taking Over (feat. Cassandra Kay)</p>
                            </div>
                            <div class="tag-nest"> <i>patah </i><i>hati</i><i>music</i> </div>
                            <div class="audio-category-bg">
                                <h3>audio</h3>
                                <a class="link-media pull-right" href="#"> <span class="entypo-note-beamed"></span> </a>
                                <div class="triangle-white"></div>
                                <div class="triangle-audio-right"></div>
                            </div>
                        </div>
                    </div>
                    <!-- END OF AUDIO -->
                    <!-- PHOTO SET -->
                    <div class="col-md-4">
                        <div class="well-media">
                            <div class="vendor">
                                <div data-ride="carousel" class="carousel slide" id="carousel-dua">
                                    <ol class="carousel-indicators">
                                        <li class="" data-slide-to="0" data-target="#carousel-dua"></li>
                                        <li data-slide-to="1" data-target="#carousel-dua" class=""></li>
                                        <li data-slide-to="2" data-target="#carousel-dua" class="active"></li>
                                    </ol>
                                    <div class="carousel-inner">
                                        <div class="item"> <img class="img-responsive-media" alt="First slide" data-src="holder.js/900x500/auto/#777:#555/text:First slide" src="http://placehold.it/350x250"> </div>
                                        <div class="item"> <img class="img-responsive-media" alt="Second slide" data-src="holder.js/900x500/auto/#666:#444/text:Second slide" src="http://placehold.it/350x250"> </div>
                                        <div class="item active"> <img class="img-responsive-media" alt="Third slide" data-src="holder.js/900x500/auto/#555:#333/text:Third slide" src="http://placehold.it/350x250"> </div>
                                    </div>
                                    <a data-slide="prev" href="#carousel-dua" class="left carousel-control"> <span class="glyphicon glyphicon-chevron-left"></span> </a>
                                    <a data-slide="next" href="#carousel-dua" class="right carousel-control"> <span class="glyphicon glyphicon-chevron-right"></span> </a>
                                </div>
                            </div>
                            <div class="video-text">
                                <h2>Holyday</h2>
                                <p>It ws may last summer holyday</p>
                            </div>
                            <div class="tag-nest"> <i>angel</i><i>dark</i><i>mistic</i> </div>
                            <div class="album-category-bg">
                                <h3>Photoset</h3>
                                <a class="link-media pull-right" href="#"> <span class="entypo-picture"></span> </a>
                                <div class="triangle-white"></div>
                                <div class="triangle-album-right"></div>
                            </div>
                        </div>
                    </div>
                    <!--     END OF PHOTO SET -->
                    <!-- AUDIO -->
                    <div class="col-md-4">
                        <div class="well-media">
                            <div class="vendor">
                                <iframe width="100%" height="166" scrolling="no" frameborder="no" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/149950304&amp;color=ff5500&amp;auto_play=false&amp;hide_related=false&amp;show_artwork=true"></iframe>
                            </div>
                            <div class="video-text">
                                <h2>Terlatih Patah Hati</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            </div>
                            <div class="tag-nest"> <i>patah </i><i>hati</i><i>music</i> </div>
                            <div class="audio-category-bg">
                                <h3>audio</h3>
                                <a class="link-media pull-right" href="#"> <span class="entypo-note-beamed"></span> </a>
                                <div class="triangle-white"></div>
                                <div class="triangle-audio-right"></div>
                            </div>
                        </div>
                    </div>
                    <!-- END OF AUDIO -->
                </div>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
  export default {
    name: 'BlogMansory'
  }
</script>



// WEBPACK FOOTER //
// BlogMansory.vue?2d803b6d